<template>
  <div>
    <top-header v-bind:title="$t('learningDepartments')">
      <header-button icon="mdi-plus-box"
                     right
                     slot="right-button"
                     v-bind:label="$t('add')"
                     v-bind:to="{ name: 'learning-department-add' }" />
    </top-header>
    <v-container>
      <learningDepartment-table-card item-route-name="learning-department"
                          v-bind:loading="loading"
                          v-bind:learningDepartments="learningDepartments" />
    </v-container>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import HeaderButton from '@/components/common/HeaderButton.vue'
  import TopHeader from '@/components/common/TopHeader.vue'
  import LearningDepartmentTableCard from '@/components/learning/LearningDepartmentTableCard.vue'

  export default {
    components: {
      HeaderButton,
      LearningDepartmentTableCard,
      TopHeader
    },
    computed: {
      ...mapGetters({
        learningDepartments: 'learning/learningDepartments'
      })
    },
    async created() {
      this.loading = true

      await this.loadLearningDepartments()

      this.loading = false
    },
    data: () => ({
      loading: false
    }),
    methods: {
      ...mapActions({
        loadLearningDepartments: 'learning/loadLearningDepartments'
      })
    },
    name: 'LearningDepartments'
  }
</script>

<i18n>
  {
    "de": {
      "add": "Neu",
      "learningDepartments": "Abteilungen"
    },
    "en": {
      "add": "Add",
      "learningDepartments": "LearningDepartments"
    }
  }
</i18n>